var makeString = require('./helper/makeString');

module.exports = function strRightBack(str, sep) {
  str = makeString(str);
  sep = makeString(sep);
  var pos = !sep ? -1 : str.lastIndexOf(sep);
  return~ pos ? str.slice(pos + sep.length, str.length) : str;
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/underscore.string/strRightBack.js
 ** module id = 445
 ** module chunks = 0
 **/